module.exports = __webpack_public_path__ + "img/photo.3114441a.png";